import { Doughnut as Pie, Chart } from "react-chartjs-2";

import { useEffect, useState } from "react";
import { getMultiPieChart } from "../../Helper/index";
import React from "react";
const datasets = {
  labels: [],
  datasets: [
    // {
    //   backgroundColor: ["green"],
    //   data: [100],
    // },
  ],
};
const data = {
  labels: [
    "Overall Yay",
    "Overall Nay",
    "Group A Yay",
    "Group A Nay",
    "Group B Yay",
    "Group B Nay",
    "Group C Yay",
    "Group C Nay",
  ],
  datasets: [
    {
      backgroundColor: ["#AAA", "#777"],
      data: [21, 79],
    },
    {
      backgroundColor: ["hsl(0, 100%, 60%)", "hsl(0, 100%, 35%)"],
      data: [33, 67],
    },
    {
      backgroundColor: ["hsl(100, 100%, 60%)", "hsl(100, 100%, 35%)"],
      data: [20, 80],
    },
    {
      backgroundColor: ["hsl(180, 100%, 60%)", "hsl(180, 100%, 35%)"],
      data: [10, 90],
    },
  ],
};
const VentriCularTachycardiaPie = React.memo(
  ({ allTeamsAssessmentResults, orgUsers, filters = [] }) => {
    const [ventriCularTachycardia, setVentriCularTachycardia] = useState();
    console.log("ventriCularTachycardia", ventriCularTachycardia);

    useEffect(() => {
      VentriCularTachycardiaFunction();
    }, [allTeamsAssessmentResults]);

    const VentriCularTachycardiaFunction = async () => {
      await setVentriCularTachycardia({});
      let rythmCount = 0;
      const allAtrialFibrillation = allTeamsAssessmentResults.map((assess) => {
        return assess.coached.filter((coach) => {
          if (coach.rhythm === "Ventricular Tachycardia") {
            rythmCount++;
            return coach;
          }
        });
      });
      getMultiPieChart(
        rythmCount,
        allAtrialFibrillation,
        setVentriCularTachycardia
      );
    };

    return (
      <div className="pieOuterWrapper">
        <div className="pieWrapper">
        <span>Ventricular Tachycardia</span>
          {ventriCularTachycardia?.labels && (
            <div className="piieee">
              <Pie
                type="pie"
                data={
                  allTeamsAssessmentResults.length === 0
                    ? datasets
                    : ventriCularTachycardia
                }
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  // plugins: {
                  //   legend: {
                  //     labels: {
                  //       generateLabels: function (chart) {
                  //         // Get the default label list
                  //         console.log("labelsOriginal", chart);

                  //         const original =
                  //           Chart.overrides.pie.plugins.legend.labels
                  //             .generateLabels;
                  //         const labelsOriginal = original.call(this, chart);
                  //         console.log("labelsOriginal", labelsOriginal);
                  //         // Build an array of colors used in the datasets of the chart
                  //         var datasetColors = chart.data.datasets.map(function (
                  //           e
                  //         ) {
                  //           return e.backgroundColor;
                  //         });
                  //         datasetColors = datasetColors.flat();

                  //         // Modify the color and hide state of each label
                  //         labelsOriginal.forEach((label) => {
                  //           // There are twice as many labels as there are datasets. This converts the label index into the corresponding dataset index
                  //           label.datasetIndex =
                  //             (label.index - (label.index % 2)) / 2;

                  //           // The hidden state must match the dataset's hidden state
                  //           label.hidden = !chart.isDatasetVisible(
                  //             label.datasetIndex
                  //           );

                  //           // Change the color to match the dataset
                  //           label.fillStyle = datasetColors[label.index];
                  //         });

                  //         return labelsOriginal;
                  //       },
                  //     },
                  //     onClick: function (mouseEvent, legendItem, legend) {
                  //       // toggle the visibility of the dataset from what it currently is
                  //       legend.chart.getDatasetMeta(
                  //         legendItem.datasetIndex
                  //       ).hidden = legend.chart.isDatasetVisible(
                  //         legendItem.datasetIndex
                  //       );
                  //       legend.chart.update();
                  //     },
                  //   },
                  //   tooltip: {
                  //     callbacks: {
                  //       label: function (context) {
                  //         console.log("context");
                  //         const labelIndex =
                  //           context.datasetIndex * 2 + context.dataIndex;
                  //         return (
                  //           context.chart.data.labels[labelIndex] +
                  //           ": " +
                  //           context.formattedValue
                  //         );
                  //       },
                  //     },
                  //   },
                  // },
                }}
              />
            </div>
          )}
        </div>
        {/* <div className=" pieName mt-2 p-1 text-center">
          Ventricular Tachycardia
        </div> */}
      </div>
    );
  }
);

export default VentriCularTachycardiaPie;
